module.exports = __webpack_public_path__ + "img/infoSell.a01ac9f8.svg";